import { TableChart } from '@mui/icons-material'
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, List, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material'
import { useState } from 'react'
import { PriceTable } from '../../Model/PriceTableModel'

interface Props {
  open: boolean
  priceTables: PriceTable[]
  onClose: () => void
  onConfirm: (ids: number[]) => void
}

export default function PriceTablePickerDialog({ open, priceTables, onClose, onConfirm }: Props) {
  const [selected, setSelected] = useState<number[]>([])

  function toggle(id: number) {
    setSelected(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    )
  }

  function handleConfirm() {
    onConfirm(selected)
    setSelected([])
  }

  function handleClose() {
    setSelected([])
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth
      PaperProps={{ sx: { borderRadius: 3, maxHeight: '75vh' } }}>
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h3">Selecionar Tabela de Preço</Typography>
          {selected.length > 0 && (
            <Typography variant="body2" color="primary">
              {selected.length} selecionada{selected.length !== 1 ? 's' : ''}
            </Typography>
          )}
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        <Divider />
        {priceTables.length === 0 ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 6, gap: 1, color: 'text.disabled' }}>
            <TableChart sx={{ fontSize: 48 }} />
            <Typography variant="body2">Nenhuma tabela cadastrada</Typography>
          </Box>
        ) : (
          <List disablePadding>
            {priceTables.map(pt => (
              <ListItem key={pt.id} disablePadding divider>
                <ListItemButton onClick={() => toggle(pt.id || 0)} sx={{ gap: 1 }}>
                  <Checkbox checked={selected.includes(pt.id || 0)} size="small" disableRipple />
                  <ListItemText primary={pt.name} primaryTypographyProps={{ variant: 'body1' }} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button onClick={handleClose} color="inherit">Cancelar</Button>
        <Button variant="contained" disabled={!selected.length} onClick={handleConfirm}>
          {selected.length > 0 ? `Adicionar (${selected.length})` : 'Adicionar'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
